import { Injectable } from '@angular/core';
import { ComponentType } from '@angular/cdk/portal';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';

import { IDialogParams } from '@app/core/models/dialog.model';
import { CustomSnackbarComponent } from '../presentation/mo-layout/components/custom-snackbar/custom-snackbar.component';
import { ILargeContentConfig } from '../core/models/app.model';

@Injectable({ providedIn: 'root' })
export class UIService {
  private _snackRef: MatSnackBarRef<any>;

  constructor(private _dialog: MatDialog, private _snackBar: MatSnackBar) {}

  public showConfirmDialog(message: string, confirm: Function, cancel?: Function) {
    const dataDialog: IDialogParams = {
      title: '',
      message: `<p class="modal-body__message text-center"> ${message} </p> `,
      isHTMLMessage: true,
      callbacks: {
        ok: confirm,
        cancel: cancel,
      },
      infoButton: {
        showButtonOk: true,
        showButtonClose: true,
        showButtonCancel: true,
        textCancel: 'No, regresar',
        textOk: 'Sí, estoy seguro',
      },
    };

    // this.showDialog(dataDialog);
  }
  public showSuccessDialog(message: string, confirm?: Function, cancel?: Function) {
    const dataDialog: IDialogParams = {
      title: '',
      message: `<p class="modal-body__message text-center"> ${message} </p> `,
      isHTMLMessage: true,
      callbacks: {
        ok: confirm,
      },
      infoButton: {
        showButtonOk: true,
        showButtonClose: true,
        showButtonCancel: false,
        textCancel: 'No, regresar',
        textOk: 'Cerrar',
      },
    };
  }

  public showSnackbar(message, type = 'error', className = 'snackbar-error', time = 10000) {
    this._snackRef = this._snackBar.openFromComponent(CustomSnackbarComponent, {
      data: { message, type },
      panelClass: [className],
      duration: time,
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
    });
    this._snackRef.onAction().subscribe(() => {
      this._snackRef.dismiss();
    });
  }

  public isLargeContent(): ILargeContentConfig {
    const screenHeight: number = window.innerHeight;
    const contentHeight: number = document.querySelector('.box').getBoundingClientRect().height;
    const maxHeight: number = (85 * screenHeight) / 100;
    return {
      isLargeContent: contentHeight >= maxHeight ? true : false,
      screenHeight,
      contentHeight,
      maxHeight,
    };
  }

  public firstLetterUppercase(name: string) {
    const sliceName = name.slice(1).toLowerCase();
    const firstLetterUppercase = name.charAt(0).toUpperCase();
    const fullName = `${firstLetterUppercase}${sliceName}`;
    return fullName;
  }

  public openDialogValidationWithoutToken() {
    const dataStatus = {
      title: `¡Felicidades!`,
      message: `Para ver la respuesta de tu validación de identidad, continua con la creación de tu cuenta o si iniciaste el proceso desde tu escritorio puedes continuar desde ahí.`,
      textOk: `Ir al resumen`,
    };

    const data: IDialogParams = {
      title: dataStatus.title,
      message: dataStatus.message,
      isHTMLMessage: false,
      infoButton: {
        showButtonOk: true,
        showButtonClose: false,
        showButtonCancel: false,
        textOk: dataStatus.textOk,
      },
    };

    const confDialog = {
      data,
      disableClose: true,
      panelClass: 'mat-modal-document',
    };

    // this.openDialog(DialogValidationComponent, confDialog);
  }
}
